import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { setDefaultSetting } from "../store";
import { setCountryKeyValue } from "@pages/SettingGeneral/Language/store";
import { fetchCountry } from "./helper";

export function useSyncDefaultSettingLanguage(data: any, defaultSetting: any) {
    useEffect(() => {
        if (data.data === undefined) return;
        setDefaultSetting({
            ...defaultSetting,
            language: { data: [...data.data] },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
}

export function useInitLanguageUrl(
    franchiseID: string,
    setUrl: (url: string) => void
) {
    useEffect(() => {
        setUrl(
            `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/getData?type=language&franchiseId=${franchiseID}`
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export function useInitLanguageForm(
    rowData: any,
    i18nextLng: string,
    setSelectCountry: (val: boolean) => void,
    setSelectName: (val: boolean) => void,
    setIsNotImg: (val: boolean) => void,
    setSelectImage: (val: boolean) => void,
    setLangue: (val: string) => void,
    setAbbreviation: (val: string) => void,
    setDisplayName: (val: string) => void,
    setCountry: (val: any) => void,
    setUploadedImage: (val: any) => void,
    setCountryKey: (val: string) => void,
    setAdvancedDisplayName: (val: any) => void,
    setCountryOptions: (val: any[]) => void,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    const { t } = useTranslation();

    useEffect(() => {
        setSelectCountry(false);
        setSelectName(false);
        setIsNotImg(false);
        setSelectImage(false);
        setLangue(t(rowData.language));
        setAbbreviation(rowData.abbreviation);
        setDisplayName(rowData.display_name);
        setCountry({ ...rowData.country, label: t(rowData.country.label) });
        setUploadedImage(
            rowData.url_image.startsWith("https://flagpedia.net/data/flags/h80")
                ? ""
                : rowData.url_image
        );
        setCountryKeyValue(rowData.country.code ?? "");
        setCountryKey(rowData.country.code ?? "");
        setAdvancedDisplayName(rowData.advancedDisplayName);
        fetchCountry(i18nextLng, setCountryOptions, t, fetchGlobal);
        // eslint-disable-next-line
    }, [rowData, t]);
}

export function useSyncBorderColor(
    selectImage: boolean,
    isNotImg: boolean,
    setBorderColor: (val: string) => void,
    setSelectImage: (val: boolean) => void
) {
    useEffect(() => {
        setBorderColor(selectImage || isNotImg ? "red" : "#c3bfbe");
        if (isNotImg) setSelectImage(false);
    }, [isNotImg, selectImage, setBorderColor, setSelectImage]);
}
